<template>
<div class="chapter">
<div class="inner_page">
<p class="part-num" id="P1">Part I</p>
<p class="part-title">CRYPTIDS, MONSTERS AND OUT-OF-PLACE ANIMALS</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?fed7009a